module.exports = __webpack_public_path__ + "static/DSC_7874-6933c98dba45ec6c66f39d477d789085.jpg";